import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

import Puerta from './components/Puerta';
import Panel from './components/Panel';
import Hoy from './components/Hoy';
import Fincas from './components/Fincas';
import Empresas from './components/Empresas';
import RecibirLeche from './components/RecibirLeche';
import Produccion from './components/Produccion';
import Vender from './components/Vender';
import Cartera from './components/Cartera';
import Prestado from './components/Prestado';
import PorCobrar from './components/PorCobrar';
import Contador from './components/Contador';
import Papeles from './components/Papeles';
import Ajustes from './components/Ajustes';
import { esImagenValida } from './utils/logo';
import Rutas from './components/Rutas';
import Nomina from './components/Nomina';
import Ganado from './components/Ganado';
import Contabilidad from './components/Contabilidad';
import Insumos from './components/Insumos';
import Inventario from './components/Inventario';
import Apuntes from './components/Apuntes';
import Productos from './components/Productos';

// El menú, en el orden en que ocurre el negocio: primero entra la leche,
// después se transforma, después se vende. Que el menú siga la cadena real
// ahorra explicar por dónde se empieza.
const PANTALLAS = [
  { grupo: 'Cada día' },
  // HOY VA DE PRIMERA, ANTES QUE EL PANEL.
  //
  // El Panel mira treinta días y contesta «¿cómo va el mes?». Ésta contesta
  // «¿cómo va hoy?», que es lo que Gabriel tiene en la cabeza mientras está en
  // la planta con el teléfono en la mano.
  //
  // Y es la única del programa que llega A TIEMPO: si a las tres de la tarde
  // una ruta no ha reportado, todavía se puede llamar. Puesta debajo del
  // Panel, esa alerta se vería mañana — cuando ya no sirve.
  { id: 'hoy',      nombre: 'Hoy',       ico: '📅', Componente: Hoy },
  { id: 'panel',    nombre: 'Panel',     ico: '📊', Componente: Panel },
  // LOS APUNTES VAN ARRIBA, pegados al Panel.
  //
  // «Gabriel pesa los quesos y manda la información al muchacho que llena el
  // programa en la oficina.» Es lo PRIMERO que el muchacho tiene que mirar
  // cada mañana: lo que quedó anotado en la planta y todavía no está en el
  // programa. Enterrado abajo, se convierte en otra pantalla que nadie abre —
  // y entonces vuelve el WhatsApp.
  { id: 'apuntes',  nombre: 'Apuntes',   ico: '📮', Componente: Apuntes },
  { id: 'leche',    nombre: 'Leche',     ico: '🥛', Componente: RecibirLeche },
  { id: 'produccion', nombre: 'Producción', ico: '🧀', Componente: Produccion },
  { id: 'inventario', nombre: 'Inventario', ico: '❄️', Componente: Inventario },
  // Las rutas salen de adentro de Producción a su propia pestaña. Estaban al
  // fondo de otra pantalla y Carlos no las encontraba — y comparar rutas no es
  // un detalle de la producción del día: es la pregunta con la que se decide
  // dónde cuajar.
  { id: 'rutas',    nombre: 'Rutas',     ico: '🛣️', Componente: Rutas },
  // Insumos va PEGADO a Inventario, no en «La finca» con el ganado.
  //
  // Las dos contestan la misma pregunta —«¿qué tengo?»— una del queso y otra
  // del cuajo y la sal. Separadas, quien busca cuánto cuajo le queda no lo
  // encuentra: no se le ocurre buscarlo en la finca.
  { id: 'insumos',  nombre: 'Insumos',   ico: '📦', Componente: Insumos },
  { id: 'vender',   nombre: 'Vender',    ico: '🛒', Componente: Vender },
  { grupo: 'La plata' },
  // Por cobrar va PRIMERO en «La plata», antes que Clientes y Nómina.
  //
  // Los tres montones ya salían cada uno en su pantalla y ahí se quedan. Esta
  // contesta la pregunta que ninguna de las tres contestaba sola: «¿cuánta
  // plata mía está en la calle y desde cuándo?». Es la que se abre para
  // sentarse a cobrar, así que va de primera.
  { id: 'cobrar',   nombre: 'Por cobrar', ico: '💸', Componente: PorCobrar },
  // Clientes vive AQUÍ y no en «Fichas».
  //
  // Estuvo abajo, al lado de Fincas, por una simetría que era mía y no suya:
  // una pantalla es quien me vende y la otra quien me compra. Muy ordenado, y
  // Carlos preguntó dos veces dónde veía lo que le deben.
  //
  // «¿Quién me debe?» es una pregunta de plata, y se busca donde está la plata.
  // Fichas es donde uno guarda lo que casi no se toca.
  { id: 'cartera',  nombre: 'Clientes',  ico: '👥', Componente: Cartera },
  // Prestado va PEGADO a Por cobrar y Clientes, que son las otras dos de
  // «¿dónde está mi plata?».
  //
  // Existía como una lista dentro de Fincas y ahí contestaba a medias: sumaba
  // los MONTOS y no los saldos —con las cuotas eso infla la cartera en
  // millones— y no decía desde cuándo le deben, que es lo que decide a quién
  // hay que ir a buscar.
  //
  // Y contesta la que nadie contestaba: cuáles préstamos están atrapados
  // porque se intentan descontar enteros y la liquidación de esa finca no
  // alcanza nunca.
  { id: 'prestado', nombre: 'Prestado',  ico: '💵', Componente: Prestado },
  { id: 'nomina',   nombre: 'Nómina',    ico: '👷', Componente: Nomina },
  { id: 'contab',   nombre: 'Contabilidad', ico: '📒', Componente: Contabilidad },
  // El reporte que pide el contador. Va aquí, pegado a Contabilidad: son las
  // dos pantallas que se abren cuando toca rendirle cuentas a alguien de
  // afuera, y separadas habría que acordarse de que existen dos.
  { id: 'contador', nombre: 'Para el contador', ico: '🧾', Componente: Contador },
  // El archivo de papeles. Va aquí y no arriba a propósito: no es donde se
  // emite —eso pasa al vender y al pagar— sino donde se vuelve a sacar uno.
  // Puesta entre las de trabajar, invitaría a venir aquí a facturar, que es
  // justo lo que no hace.
  { id: 'papeles',  nombre: 'Papeles',   ico: '🗂️', Componente: Papeles },
  // Los datos de la empresa y el logo. Van de últimos: se llenan una vez y no
  // se vuelven a tocar, y una pantalla que se usa una vez arriba del todo le
  // quita el sitio a las que se usan a diario.
  { id: 'ajustes',  nombre: 'Ajustes',   ico: '⚙️', Componente: Ajustes },
  { grupo: 'La finca' },
  { id: 'ganado',   nombre: 'Ganado',    ico: '🐄', Componente: Ganado },
  { grupo: 'Fichas' },
  { id: 'quesos',   nombre: 'Quesos',    ico: '🧀', Componente: Productos },
  { id: 'fincas',   nombre: 'Fincas',    ico: '🚜', Componente: Fincas }
];

// Solo la ve el dueño del programa. Va aparte de PANTALLAS porque no es una
// pantalla del negocio: es de quien vende el programa.
const PANTALLA_ADMIN = { id: 'empresas', nombre: 'Empresas', ico: '🏢', Componente: Empresas };

const CLAVE_SESION = 'quesera-sesion';

// El token se pone en axios una sola vez, no en cada petición: si cada llamada
// lo pusiera a mano, la que se olvidara fallaría con un 401 que parece un
// problema de sesión y no un descuido.
//
// Se aplica de forma SÍNCRONA y no dentro de un efecto. React ejecuta los
// efectos de los hijos antes que los del padre, así que un efecto aquí llegaba
// tarde: el Panel ya había pedido sus datos sin cabecera y recibía un 401 que
// cerraba la sesión recién abierta.
function aplicarToken(token) {
  if (token) axios.defaults.headers.common.Authorization = `Bearer ${token}`;
  else delete axios.defaults.headers.common.Authorization;
  return token;
}

function leerSesion() {
  try {
    const guardada = JSON.parse(localStorage.getItem(CLAVE_SESION));
    aplicarToken(guardada?.token);
    return guardada;
  } catch {
    return null;
  }
}

function App() {
  const [sesion, setSesion] = useState(leerSesion);
  const [bloqueo, setBloqueo] = useState(null);
  // ABRE EN «HOY», NO EN EL PANEL.
  //
  // El Panel mira treinta días: es para sentarse a revisar. Al abrir el
  // teléfono en la planta la pregunta es otra —«¿cómo va hoy?»— y sobre todo:
  // si una ruta no ha reportado, eso hay que verlo al abrir y no cuando a
  // alguien se le ocurra entrar a mirar.
  const [pantalla, setPantalla] = useState('hoy');

  const salir = useCallback(() => {
    localStorage.removeItem(CLAVE_SESION);
    aplicarToken(null);
    setSesion(null);
    setPantalla('panel');
  }, []);

  // Un token vencido deja la aplicación devolviendo 401 en todas las pantallas
  // sin decir por qué. Se atrapa una vez aquí y se vuelve a la entrada.
  useEffect(() => {
    const id = axios.interceptors.response.use(
      (res) => res,
      (err) => {
        if (err.response?.status === 401 && sesion) salir();
        // 402 = la cuenta está registrada pero no activada, o venció. NO se
        // cierra la sesión: la persona entró bien, lo que falta es que el
        // dueño del programa la active. Sacarla a la pantalla de entrar la
        // haría pensar que su clave está mala.
        if (err.response?.status === 402) setBloqueo(err.response.data?.estado || 'pendiente');
        return Promise.reject(err);
      }
    );
    return () => axios.interceptors.response.eject(id);
  }, [sesion, salir]);

  // Refrescar quién es, al abrir.
  //
  // La sesión se guarda en el navegador cuando la persona entra, y de ahí sale
  // si es administradora. Si eso cambia después —como le pasó a Carlos, que se
  // volvió administrador con una migración— la pestaña no aparecería hasta
  // salir y volver a entrar, y nadie adivina que hay que hacer eso.
  //
  // Se pregunta cada vez que se abre el programa. Si falla, se deja lo que
  // había: es un refresco, no una comprobación de permiso — la de verdad está
  // en el servidor, en cada ruta.
  useEffect(() => {
    if (!sesion?.token) return;
    axios.get('/api/auth/me')
      .then(r => {
        const user = r.data || {};
        if (!!user.es_admin === !!sesion.user?.es_admin) return;
        const nueva = { ...sesion, user: { ...sesion.user, ...user } };
        localStorage.setItem(CLAVE_SESION, JSON.stringify(nueva));
        setSesion(nueva);
      })
      .catch(() => {});
    // Solo al abrir. Con `sesion` en las dependencias se llamaría en bucle:
    // guardar la sesión nueva volvería a disparar el efecto.
  }, []);   // eslint-disable-line

  const entrar = (datos) => {
    localStorage.setItem(CLAVE_SESION, JSON.stringify(datos));
    aplicarToken(datos.token);
    setSesion(datos);
  };

  if (!sesion) return <Puerta onEntrar={entrar} />;

  // La cuenta existe pero no puede entrar todavía. Se explica en vez de
  // devolver errores en cada pantalla: quien acaba de registrarse no tiene por
  // qué adivinar que lo que falta es que le activen la cuenta.
  if (bloqueo) {
    const MENSAJES = {
      pendiente: ['Su cuenta ya está creada',
        'Falta que la activemos. Escríbanos y la dejamos lista — sus datos ya están guardados aquí.'],
      vencida: ['Se venció la suscripción',
        'Escríbanos para renovarla. No se ha borrado nada: todo lo suyo queda esperando.'],
      prueba_vencida: ['Se acabaron los días de prueba',
        'Todo lo que anotó durante la prueba sigue aquí, completo. Escríbanos y ' +
        'seguimos donde lo dejó.'],
      suspendida: ['La cuenta está suspendida',
        'Escríbanos para revisarlo. Sus datos siguen aquí, completos.'],
    };
    const [titulo, texto] = MENSAJES[bloqueo] || MENSAJES.pendiente;
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center',
                    justifyContent: 'center', padding: 24 }}>
        <div className="bloque" style={{ maxWidth: 460 }}>
          <h2>{titulo}</h2>
          <div className="cuerpo">
            <p style={{ marginTop: 0 }}>{texto}</p>
            <div className="aviso">
              Entró como <strong>{sesion.user?.email}</strong>
              {sesion.user?.negocio && <> · {sesion.user.negocio}</>}
            </div>
            <div className="acciones">
              <button className="boton suave" onClick={() => setBloqueo(null)}>
                Volver a intentar
              </button>
              <button className="boton" onClick={salir}>Salir</button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const disponibles = sesion.user?.es_admin
    ? [...PANTALLAS, { grupo: 'El programa' }, PANTALLA_ADMIN]
    : PANTALLAS;
  const actual = disponibles.find(p => p.id === pantalla) || disponibles[1];
  const Componente = actual.Componente;

  return (
    <div className="armazon">
      <nav className="menu">
        {/* El logo de la empresa en vez del emoji, cuando lo hay. Quien entra
            ve la suya y no la marca del programa — que a él no le dice nada.
            Se comprueba que sea una imagen antes de pintarla: lo guardado se
            valida al entrar y al salir, pero esto se muestra en cada pantalla
            y no es sitio para confiar en una validación de hace un mes. */}
        <div className="marca">
          {esImagenValida(sesion.user?.logo)
            ? <img className="gema-logo" src={sesion.user.logo} alt="" />
            : <span className="gema">🧀</span>}
          <div>
            <b>{sesion.user?.negocio || 'Quesera'}</b>
            <span>{sesion.user?.negocio ? 'Quesera' : ''}</span>
          </div>
        </div>

        {disponibles.map((p, i) => p.grupo
          ? <div key={'g' + i} className="grupo">{p.grupo}</div>
          : (
            <button
              key={p.id}
              className={'opcion' + (pantalla === p.id ? ' activa' : '')}
              onClick={() => setPantalla(p.id)}
            >
              <span className="ico">{p.ico}</span>
              {p.nombre}
            </button>
          )
        )}

        {/* Dos documentos, y van en este orden a propósito.
            «Empezar» está ordenado por el día —qué hago primero— y sirve para
            APRENDER: uno no sabe qué sigue y la guía se lo dice. El manual está
            ordenado por pantallas y sirve para CONSULTAR: uno ya sabe qué busca.
            Quien abre el programa por primera vez necesita el primero, así que
            va primero. */}
        <a className="opcion" href="/empezar/" target="_blank" rel="noopener noreferrer">
          <span className="ico">🚀</span>
          Empezar aquí
        </a>
        <a className="opcion" href="/manual/" target="_blank" rel="noopener noreferrer">
          <span className="ico">📖</span>
          Manual
        </a>

        <button className="opcion salir" onClick={salir}>
          <span className="ico">🚪</span>
          Salir
        </button>
      </nav>

      <main className="lienzo">
        <Componente irA={setPantalla} />
      </main>
    </div>
  );
}

export default App;
